import { Component, Inject } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose
} from '@angular/material/dialog';
import { SearchParameter } from '../../../dto/search-parameter';
import { FilterInput } from '../filter-input';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatSlider, MatSliderRangeThumb } from '@angular/material/slider';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'pcp-numeric-filter',
  templateUrl: './numeric-filter.component.html',
  styleUrls: ['./numeric-filter.component.scss'],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    MatSlider,
    MatSliderRangeThumb,
    MatDialogActions,
    MatButton,
    MatDialogClose
  ]
})
export class NumericFilterComponent {
  constructor(
    public dialogRef: MatDialogRef<NumericFilterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FilterInput<number>
  ) {}

  capitalizeFirstLetter(name: string) {
    return name.charAt(0).toUpperCase() + name.slice(1);
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.dialogRef.close(this.getParameters());
    }
  }

  getParameters() {
    return new SearchParameter(
      'search' + this.capitalizeFirstLetter(this.data.col.name),
      [this.data.from?.toString() ?? '', this.data.to?.toString() ?? ''],
      this.data.col.type
    );
  }
}
